<template>
  <div id="drawApp">
    <el-container>
      <el-header height="60px" style="background-image: linear-gradient(-244deg, #92C5F8 0%, #54A3F2 100%);">
        <Header></Header>
      </el-header>
      <el-container>
        <el-aside width="200px"  class="aside">
          <inspect-left></inspect-left>
        </el-aside>
        <el-main class="main">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" >
              <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import Header from './Header.vue';
  import InspectLeft from './InspectSuperviseLeft.vue';
  export default {
    components: {
      Header,
      InspectLeft
    },
    data(){
      return{
        clientHeight: document.body.clientHeight,
      }
    },
    watch: {
      clientHeight (val) {
        if (!this.timer) {
          this.clientHeight = val;
          this.timer = true;
          let that = this;
          setTimeout(function () {
            that.height();
            that.timer = false
          }, 100)
        }
      }
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-image:url()');
      this.height();
      const that = this;
      window.onresize = () => {
        return (() => {
          window.clientHeight = document.body.clientHeight;
          that.clientHeight = window.clientHeight
        })()
      }
    },
    methods: {
      height(){
        var mainHeight = "height:"+(document.body.clientHeight-68)+"px;background-color: #F2F6FC";
        var asideHeight = "height:"+(document.body.clientHeight-68)+"px;width:230px";
        document.querySelector('.main').setAttribute('style',mainHeight);
        document.querySelector('.aside').setAttribute('style',asideHeight);
      }
    }
  }
</script>
<style>
  html,body,#drawApp{
    height: 100%;
    margin-top:0;
    margin-left:0;
    margin-right: 0;
    min-width: 1000px;
  }
</style>



// WEBPACK FOOTER //
// src/components/inspectSuperviseHome.vue